(function (angular) {
    'use strict';

    angular.module('shared')
        .factory("badgeService", [function () {

            var count = 0;
            // Return the public API.
            return ({
                getCount: getCount,
                setCount: setCount
            });
            // ---
            // PUBLIC METHODS.
            // ---
            // I return the currently-active count.
            function getCount() {
                return (count);
            }
            // I set the active count.
            function setCount(newCount) {
                count = newCount;
            }
        }]);

})(window.angular);
